import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './index.scss';
import CautionIcon from '../../assets/common/images/icon/caution.png';
import request from '../../utils/request';
import { resetAuthentication } from '../../authentication/actions';
import { trans } from '../../localization';


function AccountDeletion(props) {
  const { history, resetAuthenticationConnect } = props;


  const handleDeleteAccount = async () => {
    await request.deleteAccount();
    resetAuthenticationConnect();
  }
  const handleCancelDeleteAccount = () => {
    history.push('/dashboard');
  }

  return (
    <div className="account-deletion-container">
      <div className="account-deletion-content">    
        <div>
          <img src={CautionIcon} alt="caution" className="caution-icon" />
        </div>
        <div className="account-deletion-title">{trans('del_title')}</div>
        <div className="account-deletion-description">
          <p>
            {trans('del_desc')}
          </p>
          <div className="account-deletion-btns">
            <button type="button" className="btn btn-danger" onClick={handleDeleteAccount}>{trans('del_btn_yes')}</button>
            <button type="button" className="btn btn-white" onClick={handleCancelDeleteAccount}>{trans('del_btn_no')}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// export default AccountDeletion;

const mapDispatchToProps = dispatch => ({
  resetAuthenticationConnect: () => {
    dispatch(resetAuthentication());
  },
});

export default withRouter(connect(null, mapDispatchToProps)(AccountDeletion));



// WEBPACK FOOTER //
// ./foody/src/pages/AccountDeletion/index.jsx